import ApiGetOptions from '@/datatypes/api-get-options';
import ApiPostOptions from '@/datatypes/api-post-options';
import ApiService from '@/services/api/ApiService';
import decamelizeKeysDeep from 'decamelize-keys-deep';

export default class UserService extends ApiService {
  public list(options) {
    return this.call(new ApiGetOptions(
      {
        url: '/users',
        params: options,
      },
    ));
  }

  public show(userId) {
    return this.call(new ApiGetOptions(
      {
        url: `/users/${userId}`,
      },
    ));
  }

  public transferDocuments(fromUserId, toUserId) {
    return this.call(new ApiPostOptions(
      {
        url: `/users/${fromUserId}/documents/transfer`,
        data: decamelizeKeysDeep({
          toUserId,
        }),
      },
    ));
  }
}
